import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import OnboardLayout from "../components/layouts/OnboardLayout/OnboardLayout";
import AuthLayout from "../components/layouts/AuthLayout/AuthLayout";
import { ROUTES } from "../routes";

const AuthGuard = () => {
  const location = useLocation();

  const isAuthenticated = useSelector(
    (state) => state?.persist?.isUserLoggedin
  );

  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );

  if (!isAuthenticated) {
    return (
      <OnboardLayout>
        <Navigate to={ROUTES.LOGIN} replace />
      </OnboardLayout>
    );
  }

  if (kycStatus === undefined || kycStatus === null) {
    return null;
  }

  if (kycStatus !== "APPROVED" && location.pathname !== ROUTES.VERIFY_KYC) {
    return <Navigate to={ROUTES.VERIFY_KYC} replace />;
  }

  if (kycStatus === "APPROVED" && location.pathname === ROUTES.VERIFY_KYC) {
    return <Navigate to={ROUTES.BUY} replace />;
  }

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

export default AuthGuard;
